import * as React from 'react';
import { ReactComponent as DocBoxIconSVG } from '../../assets/icons/mevo/ic_doc.svg';
import IconPattern, { IconProps } from './_IconPattern';

const DocBoxIcon: React.FunctionComponent<IconProps> = (props) => {
  return <IconPattern component={DocBoxIconSVG} variantPlaces={2} {...props} />;
};

export default DocBoxIcon;
